import { BUILDER_LINKS, builderPrices } from '../data/builder'
import { variantIdOf } from '../data/productLinks'

/**
 * Add-ons that ride along with the pack a customer checks out on the offer cards
 * (today: RX Capability Inserts on a Complete System or multipack).
 * Set right before routing; any upgrade accepted in a popup keeps them.
 */
let pendingRx = 0

export function rxInsertConnected(): boolean {
  return Boolean(variantIdOf(BUILDER_LINKS.rxInsert))
}

export function setPendingRx(quantity: number) {
  pendingRx = rxInsertConnected() ? Math.max(0, Math.floor(quantity)) : 0
}

/** Appends the pending RX line to a Shopify cart permalink and reports the extra value. */
export function applyCartAddons(href: string): { href: string; extraValue: number; rx: number } {
  const rxId = variantIdOf(BUILDER_LINKS.rxInsert)
  if (!href || pendingRx <= 0 || !rxId) return { href, extraValue: 0, rx: 0 }
  const [path, query] = href.split('?')
  const params = new URLSearchParams(query ?? '')
  params.set('attributes[RX inserts]', String(pendingRx))
  return {
    href: `${path},${rxId}:${pendingRx}?${params.toString()}`,
    extraValue: Math.round(pendingRx * builderPrices.rxInsert * 100) / 100,
    rx: pendingRx,
  }
}
